import { ComponentPropsWithoutRef } from "react";
import * as styles from "./WrapperComponents.css";
import clsx from "clsx";

export type WrapperComponentsProps = ComponentPropsWithoutRef<"div"> & {
  noPaddingTop?: boolean;
};

export const WrapperComponents = ({
  className,
  children,
  noPaddingTop = false,
  ...props
}: WrapperComponentsProps) => {
  return (
    <div
      className={clsx(
        className,
        styles.wrapper({ noPaddingTop: noPaddingTop })
      )}
      {...props}
    >
      {children}
    </div>
  );
};
